import { useEffect, useState } from "react";
import { useAppSelector } from "../../../../../store";
import { storedLocale } from "../../../../Authentication/util";
import { useGetAnnualIncomeBreakdownQuery } from "../../../../../services/AnnualIncomeDashboard/annualIncomeDashboardAPI";
import type { IncomeBreakdownApiResponse } from "../../IncomeBreakdown/IncomeBreakdown.api.types";

export const FetchAnnualIncomeBreakdownData = (period: string) => {
  const { user, configuration } = useAppSelector((state) => state.boot);

  const {
    data: payloadData,
    isFetching,
    isError,
    refetch,
  } = useGetAnnualIncomeBreakdownQuery({
    locale: storedLocale(),
    period: period,
    abo: user.abo,
    aff: user.aff,
    isoCountryCode: user.isoCountryCode,
  });

  const [isLoading, setIsLoading] = useState(true);
  const [errorStatus, setErrorStatus] = useState(false);
  const [annualIncomeBreakdownData, setAnnualIncomeBreakdownData] = useState<IncomeBreakdownApiResponse | undefined>(
    undefined,
  );

  useEffect(() => {
    setIsLoading(isFetching);
    setErrorStatus(isError);
    if (payloadData && !isFetching && !isError) {
      setAnnualIncomeBreakdownData(payloadData as IncomeBreakdownApiResponse);
    }
  }, [isFetching, period, isError, payloadData]);

  return {
    isLoading,
    errorStatus,
    refetch,
    annualIncomeBreakdownData,
  };
};
